module.exports = __webpack_public_path__ + "static/media/buy-ticket.e3a9a15d.svg";